function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* globals window, document */

import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../Icon';
import { text } from '../../../styles/colors';
import { CrossIcon } from '../../Icons';
import { Wrapper, CloseIconWrapper, ScrollableContent, Frame, preventScroll, SLIDE_ANIMATION_DURATION } from './style';
var Content = /*#__PURE__*/function (_React$Component) {
  _inherits(Content, _React$Component);
  var _super = _createSuper(Content);
  function Content(props) {
    var _this;
    _classCallCheck(this, Content);
    _this = _super.call(this, props);

    // Because overflow hidden will lose scroll position
    // We need to remember it
    _defineProperty(_assertThisInitialized(_this), "content", /*#__PURE__*/React.createRef());
    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var scrollPosition = _this.state.scrollPosition;
      var _document = document,
        body = _document.body;
      body.style.cssText = preventScroll;
      body.style.top = "-".concat(scrollPosition, "px");
    });
    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      var scrollPosition = _this.state.scrollPosition;
      var _document2 = document,
        body = _document2.body;

      // Scroll back to where you've been and remove preventScroll styles
      body.style.cssText = '';
      window.scrollTo(0, scrollPosition);
      document.removeEventListener('click', _this.handleOutsideClick, true);
      document.removeEventListener('keydown', _this.handleKeyPress, true);
      if (_this.timeout) clearTimeout(_this.timeout);
    });
    _defineProperty(_assertThisInitialized(_this), "handleKeyPress", function (e) {
      var _assertThisInitialize = _assertThisInitialized(_this),
        handleClose = _assertThisInitialize.handleClose;
      if (e.keyCode === 27) {
        handleClose(e);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleOutsideClick", function (e) {
      var _assertThisInitialize2 = _assertThisInitialized(_this),
        handleClose = _assertThisInitialize2.handleClose;
      var withOutsideClose = _this.props.withOutsideClose;
      if (withOutsideClose && !_this.contentContainsTarget(e.target)) {
        handleClose(e);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleClose", function (e) {
      e.stopPropagation();
      var _this$props = _this.props,
        animation = _this$props.animation,
        onClose = _this$props.onClose;
      _this.setState({
        closed: true
      });
      if (onClose) {
        if (animation === 'slideFromRight') {
          _this.timeout = setTimeout(function () {
            return onClose(e);
          }, SLIDE_ANIMATION_DURATION);
        } else {
          onClose(e);
        }
      }
    });
    _this.state = {
      scrollPosition: window.pageYOffset,
      closed: false
    };
    document.addEventListener('click', _this.handleOutsideClick, true);
    document.addEventListener('keydown', _this.handleKeyPress, true);
    return _this;
  }
  _createClass(Content, [{
    key: "contentContainsTarget",
    value: function contentContainsTarget(target) {
      return this.content.current && this.content.current.contains(target);
    }
  }, {
    key: "render",
    value: function render() {
      var closed = this.state.closed;
      var _this$props2 = this.props,
        children = _this$props2.children,
        animation = _this$props2.animation,
        withFrame = _this$props2.withFrame,
        showCloseIcon = _this$props2.showCloseIcon,
        maxWidth = _this$props2.maxWidth;
      return /*#__PURE__*/React.createElement(Wrapper, {
        closed: closed,
        animation: animation,
        maxWidth: maxWidth,
        ref: this.content
      }, showCloseIcon && /*#__PURE__*/React.createElement(CloseIconWrapper, {
        animation: animation,
        onClick: this.handleClose
      }, /*#__PURE__*/React.createElement(Icon, {
        as: CrossIcon,
        color: text.white,
        size: "sz32"
      })), /*#__PURE__*/React.createElement(ScrollableContent, {
        animation: animation
      }, withFrame ? /*#__PURE__*/React.createElement(Frame, null, children) : children));
    }
  }]);
  return Content;
}(React.Component);
Content.defaultProps = {
  children: null,
  animation: 'fadeIn',
  withOutsideClose: false,
  withFrame: true,
  onClose: null,
  showCloseIcon: true,
  maxWidth: null
};
Content.propTypes = {
  children: PropTypes.node,
  maxWidth: PropTypes.number,
  animation: PropTypes.oneOf(['fadeIn', 'slideFromRight']),
  withOutsideClose: PropTypes.bool,
  withFrame: PropTypes.bool,
  showCloseIcon: PropTypes.bool,
  onClose: PropTypes.func
};
Content.displayName = 'Content';
export default Content;